<h1>Messages collationn&eacute;s</h1>
<pannel [title]="'Filtres'" [expandable]="true" [folded]="true">
	<messages-collationnes-filters
		[user]="user"
		(filterRequest)="onFilterRequest($event)"
		>
	</messages-collationnes-filters>
</pannel>
<pannel [title]="'Liste des messages'" [headerTemplate]="listPannelHeader">
	<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
	<messages-collationnes-table
		[messages]="messages"
		(rowClick)="onRowClicked($event)"
		>
	</messages-collationnes-table>
</pannel>
<ng-template #listPannelHeader let-title="title">
	<h2>{{ title }}</h2>
	<button class="btn btn-success btn-sm pull-right" (click)="onNewMessageRequest()">
		<span>Nouveau message</span>
	</button>
</ng-template>
<create-message-collationne-dialog
	[openSubject]="openCreationDialogSubject"
	(messageCreate)="onMessageCollationneCreated()"
	>
</create-message-collationne-dialog>
<view-message-collationne-dialog
	[openSubject]="openViewDialogSubject"
	>
</view-message-collationne-dialog>